export const downloadColumns = [
  {
    field: "name",
    headerName: "Nome",
  },
  {
    field: "cpf",
    headerName: "CPF",
  },
  {
    field: "operatorName",
    headerName: "Operador",
  },
  {
    field: "specie",
    headerName: "Benefício",
  },
  {
    field: "lastReportResult",
    headerName: "Resultado",
  },
  {
    field: "lastReportDescription",
    headerName: "Descrição",
  },
  {
    field: "cityMap",
    headerName: "Cidade",
  },
  {
    field: "district",
    headerName: "Bairro",
  },
  {
    field: "lastReportDate",
    headerName: "Data do atendimento",
  },
  {
    field: "createdAt",
    headerName: "Data de inclusão",
  },
];
